import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import { createStore, get, set, del } from "idb-keyval";

const queryStore = createStore("vroom-tanstack", "queryCache");

const idbStorage = {
  getItem: async (k: string) => (await get<string>(k, queryStore)) ?? null,
  setItem: async (k: string, v: string) => set(k, v, queryStore),
  removeItem: async (k: string) => del(k, queryStore),
};

export const persister = createAsyncStoragePersister({
  storage: idbStorage,
  key: "vroom-tanstack",
});
